
const DEFAULT_FOV = 75;
const DEFAULT_HFOV = 90;

export const computeCameraFOV = (aspect:number) => {
	if(aspect <= 1){
		return DEFAULT_FOV;
	}
	return (Math.atan(Math.tan(((DEFAULT_HFOV / 2) * Math.PI) / 180) / aspect) * 2 * 180) / Math.PI;
};